import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import cn from 'classnames'

import tonImg from 'src/assets/images/ton.png'
import { Header } from 'src/components'
import { Icon } from 'src/components/ui'
import { formattedText } from 'src/utils/formattedText'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import styles from './Withdrawal.module.scss'

interface Props {
  className?: string
}

const WithdrawalPage: React.FC<Props> = ({ className }) => {
  const balanceStars = useGlobalStore((state) => state.user?.balance_stars) || 0

  const { t } = useTranslation()

  return (
    <>
      <Header variant='back' />

      <div className={cn(styles.container, className)}>
        <div className={styles.container_header}>
          <h1 className={styles.container_title}>{t('withdrawal_page.output_stars')}</h1>
          <p className={styles.container_subtitle}>{t('withdrawal_page.choose_preferred_method')}</p>
        </div>

        <div className={styles.container_allow}>
          <p>{t('withdrawal_page.available')}</p>
          <div>
            <p>{formattedText(Number(balanceStars.toFixed(2)))}</p>
            <Icon name='star' />
          </div>
        </div>

        <div className={styles.container_items}>
          {/* <Link
            to='stars'
            onClick={(e) => balanceIsZero && e.preventDefault()}
            className={cn(styles.container_item, {
              [styles.non_active]: balanceIsZero,
            })}
          >
            <img src={tgStarsImg} alt='Telegram stars' />
            <p>{t('withdrawal_page.in_account')}</p>
            <Icon name='arrow-next-white' />
          </Link> */}
          <Link to='ton' className={cn(styles.container_item)}>
            <img src={tonImg} alt='Telegram stars' />
            <p>{t('withdrawal_page.in_ton')}</p>
            <Icon name='arrow-next-white' />
          </Link>
        </div>
      </div>
    </>
  )
}

export default WithdrawalPage
